import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

export const CouponNameTypeSchema = z.enum(['FOLLOWER', 'NICKNAME', 'BRAND']);

const PostProposalApproveRequestSchema = z
  .object({
    campaignProposalId: z.number(),
    couponNameType: CouponNameTypeSchema,
  })
  .describe('PostProposalApproveRequestSchema');

export type PostProposalApproveRequest = z.infer<typeof PostProposalApproveRequestSchema>;

const PostProposalApproveResponseDataSchema = z
  .object({
    couponNo: z.number(),
    couponName: z.string(),
    couponKeyword: z.string(),
  })
  .describe('PostProposalApproveResponseDataSchema');

const PostProposalApproveResponseSchema = createApiResponseSchema(
  PostProposalApproveResponseDataSchema,
);

export type PostProposalApproveResponse = z.infer<typeof PostProposalApproveResponseSchema>;

export const postProposalApprove = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PostProposalApproveRequestSchema),
    async (params: PostProposalApproveRequest): Promise<PostProposalApproveResponse> =>
      executeStandardRequest(async () => {
        const url = `${campaignsApiPath.postProposalApprove(params.campaignProposalId)}?couponNameType=${params.couponNameType}`;
        const response = await privateHttpClient.post<PostProposalApproveResponse>(urlJoin(url));
        return response;
      }),
    validateApiResponse(PostProposalApproveResponseSchema),
  ),
);
